module.exports = __webpack_public_path__ + "1d71ede1908e1f7cb2dcc5beb8fd6dd5.png";